import * as React from 'react';

import { cn } from './cn';

export type TextareaProps =
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    compact?: boolean;
  };

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, compact = false, rows, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex w-full rounded-md border border-border-primary bg-bg-primary px-3 py-2 text-sm ring-offset-bg-secondary placeholder:text-text-tertiary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-accent-quaternary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          compact ? 'min-h-10 resize-none' : 'min-h-20',
          className,
        )}
        ref={ref}
        rows={rows ?? (compact ? 1 : undefined)}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
